import { getTypeDisplay, RAW_TO_CANONICAL } from '@/core/config/typeTranslations'

const NULLABLE_SUFFIX = '?'

function parseGeneric(input: string): { base: string; args: string[] } | null {
  const open = input.indexOf('<')
  if (open === -1 || !input.endsWith('>')) return null

  const base = input.slice(0, open)
  const inner = input.slice(open + 1, -1)
  if (!inner) return { base, args: [] }

  const args: string[] = []
  let depth = 0
  let start = 0
  for (let i = 0; i < inner.length; i += 1) {
    const ch = inner[i]
    if (ch === '<') depth += 1
    else if (ch === '>') depth -= 1
    else if (ch === ',' && depth === 0) {
      args.push(inner.slice(start, i).trim())
      start = i + 1
    }
  }
  args.push(inner.slice(start).trim())
  return { base, args }
}

function stripArraySuffix(input: string): { base: string; brackets: string } {
  const match = input.match(/^(.*?)((?:\[\])+)$/)
  if (!match) return { base: input, brackets: '' }
  return { base: match[1] ?? input, brackets: match[2] ?? '' }
}

function translateBaseName(rawBase: string, technology: string | undefined): string {
  const canonical = RAW_TO_CANONICAL[rawBase]
  if (!canonical) return rawBase
  return getTypeDisplay(canonical, technology)
}

export function translateTypeName(rawType: string | undefined, technology: string | undefined): string {
  if (!rawType) return ''

  const trimmed = rawType.trim()
  if (!trimmed) return rawType

  const isNullable = trimmed.endsWith(NULLABLE_SUFFIX)
  const withoutNullable = isNullable ? trimmed.slice(0, -1).trim() : trimmed

  const { base: withoutArrays, brackets } = stripArraySuffix(withoutNullable)

  const generic = parseGeneric(withoutArrays)
  let translated: string
  if (generic) {
    const translatedBase = translateBaseName(generic.base, technology)
    const translatedArgs = generic.args.map((arg) => translateTypeName(arg, technology))
    translated = `${translatedBase}<${translatedArgs.join(', ')}>`
  } else {
    translated = translateBaseName(withoutArrays, technology)
  }

  return `${translated}${brackets}${isNullable ? NULLABLE_SUFFIX : ''}`
}
